// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SiteTemplates_SalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** ResponseContract for POST /config/site_templates/salvar. */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SiteTemplates_SalvarResponseDados {
id: number
acao: string
}

export type SiteTemplates_SalvarResponse = ApiResponse<SiteTemplates_SalvarResponseDados>;

registerResponseContract('SiteTemplates_SalvarResponse', {
  id:   { type: 'number',  required: true },
  acao: { type: 'string',  required: true },
})
